// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__we3hX","footer":"ModalCreateQualiphyProcedure_footer__2iOK3","additionData":"ModalCreateQualiphyProcedure_additionData__YtuTp"};